<template>
	<div>
		<div id="modal_overlay" v-if="showDialog" @click="showDialog = false">
			<div class="dsd-dialog" v-if="showDialog">
				<h3 style="margin:0">This service is currently under development.</h3>
				<p
					style="text-align:center; margin-top:10px"
				>If you would like to show interest in this service then click the button below.</p>
				<button
					class="button button--primary button--small"
					style="color:#fff; margin: 20px auto 0 auto; display: block"
					@click="ShowInterest"
				>Show Interest</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: () => ({
		showDialog: false,
		service: null,
		ecu: null
	}),
	methods: {
		ShowInterest() {
			this.$parent.ShowInterest(this.service, this.ecu)
		}
	}
};
</script>

<style scoped>
.dsd-dialog {
	position: fixed;
	top: 20px;
	z-index: 999;
	width: auto !important;
	color: #333;
	background: #fff;
	padding: 20px;
	margin-top:40px;
	text-align: center;
}
#modal_overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.85);
	z-index: 99;
	display: flex;
    justify-content: center;
    align-items: center;
}
</style>